import { h, Fragment } from "preact";

const LoadingPage = () => {
  return <div class="custom-loader"></div>;
};

export default LoadingPage;
